export const isNullOrUndefined = (value: unknown): boolean => {
  return value === null || value === undefined;
};

export const isNumber = (value: unknown): boolean => {
  return typeof value === 'number';
};

export const isEmptyObject = (value: object = {}): boolean => {
  return Object.keys(value).length === 0;
};

// TODO v25.0.0: check return type later
export const isString = (value: unknown): value is string => {
  return typeof value === 'string';
};
